import React from 'react';


const style = {
	aboutUsHeader: {
		fontSize: 36,
		fontWeight: 400,
		textAlign: 'center'
	},
	parentDiv: {
		paddingTop: 40,
		fontSize: 20,
	},
};

const EANdSPolicies = () => (
	<div>
        <div className="about-us">
            <div className="container privacy">
                {/* E & S ploicies */}
                        <h3>Environmental and Social Policy</h3>
                    <div className="about-us-content">
                        <p>The E&S Policy of Ascend Capital emphasizes its commitment as a responsible NBFC to integrate E&S considerations in its operations.  The company has adopted the following E&S Policy:</p>
                    </div>
                    <h5>Ascend Capital’s Environmental and Social (E&S) Policy</h5>
                    <div className="about-us-content">
                        <p>Ascend Capital is committed to transform India's electric vehicle (EV) mobility finance industry. It aims to be a catalyst in expediting the mission of transitioning to a greener future for all by empowering individuals to embrace the potential of EVs.</p>
                        <p>Ascend Capital believes that its core values of innovation, integrity, accountability, customer first, security, quality and excellence will deliver long-term value for its valued customers and will enable the Non-Banking Financing Company (NBFC) in achieving its vision.</p>
                        <p>Building upon its core values, Ascend Capital incorporates Environmental and Social (E&S) considerations into its business operations and decision-making process. Ascend Capital will thus,</p>
                        <ul style={{listStyle:'disc',fontSize:20, lineHeight:2, textAlign:'justify', paddingLeft : 40}}>
                            <li>Adhere strictly and influence customers to continually maintain compliance to all relevant E&S legal (including occupational health and safety standards) requirements.</li>
                            <li>Identify and adopt pertinent industry best practices and relevant international E&S safeguards (e.g., IFC Performance Standards), as appropriate.</li>
                            <li>Support products that will lead to reduction in greenhouse gas emissions.</li>
                            <li>Implement initiatives within its operations to reduce waste, conserve energy, and promote recycling of materials, wherever feasible.</li>
                            <li>Establish a grievance redress mechanism, engage with stakeholders, and ensure timely redress of grievances.</li>
                            <li>Promote safe, healthy, and inclusive work environment and treating all its employees fairly.</li>
                            <li>Safeguard its customers through robust processes, data protection and effective communication.</li>
                        </ul>
                    </div>
                    <div className="about-us-content">
                        <p>Ascend Capital is thus committed to conducting its business in an environmentally sensitive, socially responsible, fair, and transparent manner. To achieve these objectives, Ascend Capital will implement this E&S policy through its E&S Risk Management Procedures.</p>
                    </div>
                </div>
        </div>
	</div>
);

export default EANdSPolicies;



// WEBPACK FOOTER //
// ./src/components/EAndSPolicies.js